import SupportCards from '@/components/SupportCards';
import styles from './ProductSupport.module.scss';

/** Installation, Care and Warranty cards shown on every product page — not product-specific data. */
const ProductSupport = () => (
  <section
    className={styles['support-section']}
    aria-labelledby="product-support-title"
    data-motion="section"
  >
    <h2 id="product-support-title" className={styles['support-title']}>
      Resources
    </h2>
    <SupportCards className={styles['support-cards']} />
  </section>
);

export default ProductSupport;
